import { useState, useEffect } from 'react'
import Templates from './components/templates'
import Wrapper from 'components/reusables/wrapper'

const TemplatesAdministration = () => {
  const [inSecondaryView, setInSecondaryView] = useState(false)

  useEffect(() => {
    const checkElements = () => {
      const element =
        document.querySelector('.editable') ||
        document.querySelector('#association-of-courses')
      setInSecondaryView(!!element)
    }

    const observer = new MutationObserver(() => {
      checkElements()
    })

    observer.observe(document.body, { childList: true, subtree: true })

    checkElements()

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <Wrapper shadow={true}>
      <Templates inMainView={!inSecondaryView} />
    </Wrapper>
  )
}

export default TemplatesAdministration
